/*
 * @Author: liujiang liujiang@shjinjia.com.cn
 * @Date: 2025-02-14 21:31:21
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @LastEditTime: 2025-02-20 17:53:33
 * @FilePath: /oak/src/store/modules/routerMap/views/stock.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 样品下单
const map = {
  prototypeList: () => import('@/views/stock/PrototypeList'),
  prototypeOrderList: () => import('@/views/stock/PrototypeOrderList'),
  prototypeOrderDetail: () => import('@/views/stock/PrototypeOrderDetail'),
  baseConfig: () => import('@/views/stock/BaseConfig'), // 用途配置列表
  createYpOrder: () => import('@/views/stock/CreateYpOrder'), // 样品下单 创建样品订单
  prototypeOrderStatistics: () => import('@/views/stock/PrototypeOrderStatistics'),
  hrppList: () => import('@/views/stock/HrppList'), // 样品下单 红人品牌列表
  sampleApplication: () => import('@/views/stock/SampleApplication'), // 样品申请单
  createSampleApplication: () => import('@/views/stock/SampleApplication/Detail'), // 样品申请单编辑
  sampleApplicationDetail: () => import('@/views/stock/SampleApplication/Detail') // 样品申请单详情
}

export default map
